import { Level } from "./types";

export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 400;
export const GROUND_Y = 316; // Top of grass (400 - 84)
export const CHAR_WIDTH = 32;
export const CHAR_HEIGHT = 58;

export const levels: Level[] = [
  {
    id: 1,
    name: "The Beginning",
    spawnPoint: { x: 50, y: GROUND_Y - CHAR_HEIGHT },
    portalPosition: { x: 720, y: GROUND_Y - 80 },
    platforms: [],
  },
  {
    id: 2,
    name: "First Jump",
    spawnPoint: { x: 50, y: GROUND_Y - CHAR_HEIGHT },
    portalPosition: { x: 700, y: 76 },
    platforms: [
      { x: 250, y: 260, width: 120 },
      { x: 450, y: 210, width: 120 },
      { x: 650, y: 160, width: 120 },
    ],
  },
  {
    id: 3,
    name: "Stepping Stones",
    hasStars: true,
    starSpawnRate: 1000,
    spawnPoint: { x: 50, y: GROUND_Y - CHAR_HEIGHT },
    portalPosition: { x: 720, y: GROUND_Y - 72 },
    platforms: [
      { x: 150, y: 250, width: 80 },
      { x: 280, y: 200, width: 80 },
      { x: 410, y: 150, width: 80 },
      { x: 540, y: 200, width: 80 },
      { x: 670, y: 250, width: 80 },
    ],
  },
];
